export enum MESAGE_TYPE {
  SUCCESS = "SUCCESS",
}
